<div class="cmn-dialog-card-view mesh-gradient">
    <button class="dialog-close-btn" (click)="closeDialog()">
        <img class="cross-icon" src="assets/svg/icons/cross.svg" />
    </button>
    <div class="dialog-header">
        <div class="dialog-header-icon">
            <img src="assets/svg/icons/badge-success-gb.svg" alt="" />
        </div>
        <h1 class="dialog-header-title">Klinq Points Redeemed!</h1>
    </div>
    <mat-dialog-content>
        <div class="dialog-body">
            <p class="fs-base text-primary-50">Your loan just got lighter with the discount!</p>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <div class="dialog-actions">
            <div class="dialog-actions-btn">
                <button type="button" class="primary-fill-btn btn-w100" (click)="submit()">Got It</button>
            </div>
        </div>
    </mat-dialog-actions>
</div>
